import { BASE_URL, MOBILE_BASE_URL } from "../api_const"

export const URL_CONTACT_US_FORM_SUBMIT = BASE_URL + "/create/contacts"